import {
  FETCH_OFFLINE_TOPUPS,
  FETCH_OFFLINE_TOPUPS_SUCCESS,
  FETCH_OFFLINE_TOPUPS_FAILED,
  SUBMIT_OFFLINE_TOPUP,
  SUBMIT_OFFLINE_TOPUP_SUCCESS,
  SUBMIT_OFFLINE_TOPUP_FAILED,
  APPROVE_OFFLINE_TOPUP,
  REJECT_OFFLINE_TOPUP,
  CLEAR_OFFLINE_TOPUP_MESSAGE,
  FETCH_OFFLINE_TOPUP_SETTINGS,
  FETCH_OFFLINE_TOPUP_SETTINGS_SUCCESS,
  FETCH_OFFLINE_TOPUP_SETTINGS_FAILED,
  EDIT_OFFLINE_TOPUP_SETTINGS,
} from "../store/types";

const INITIAL_STATE = {
  topups: null,
  loading: false,
  submitting: false,
  submitSuccess: false,
  error: {
    flag: false,
    msg: null,
  },
  settings: null,
  settingsLoading: false,
};

export const offlineTopupReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_OFFLINE_TOPUPS:
      return { ...state, loading: true };
    case FETCH_OFFLINE_TOPUPS_SUCCESS:
      return { ...state, topups: action.payload, loading: false };
    case FETCH_OFFLINE_TOPUPS_FAILED:
      return {
        ...state,
        topups: null,
        loading: false,
        error: { flag: true, msg: action.payload },
      };

    case SUBMIT_OFFLINE_TOPUP:
      return { ...state, submitting: true, submitSuccess: false, error: { flag: false, msg: null } };
    case SUBMIT_OFFLINE_TOPUP_SUCCESS:
      return { ...state, submitting: false, submitSuccess: true };
    case SUBMIT_OFFLINE_TOPUP_FAILED:
      return {
        ...state,
        submitting: false,
        submitSuccess: false,
        error: { flag: true, msg: action.payload },
      };

    case APPROVE_OFFLINE_TOPUP:
    case REJECT_OFFLINE_TOPUP:
      return state;

    case CLEAR_OFFLINE_TOPUP_MESSAGE:
      return {
        ...state,
        submitting: false,
        submitSuccess: false,
        error: { flag: false, msg: null },
      };

    case FETCH_OFFLINE_TOPUP_SETTINGS:
      return { ...state, settingsLoading: true };
    case FETCH_OFFLINE_TOPUP_SETTINGS_SUCCESS:
      return { ...state, settings: action.payload, settingsLoading: false };
    case FETCH_OFFLINE_TOPUP_SETTINGS_FAILED:
      return { ...state, settingsLoading: false };
    case EDIT_OFFLINE_TOPUP_SETTINGS:
      return { ...state, settings: action.payload };

    default:
      return state;
  }
};
